var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          attrs: {
            cols: _vm.cols,
            "form-context": _vm.formContext,
            icon: "inticon-autoclaim_money",
            title: "Verrechnungssätze",
          },
          on: { save: _vm.saveFirmPresets },
        },
        [
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gebühr Bereitstellung Hebebühne",
                  property: "feeLiftingPlatform",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gebühr Fahrzeugverbringung",
                  property: "feeVehicleMovement",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gebühr Probefahrt",
                  property: "feeTestDrive",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Gebühr Fahrzeugreinigung",
                  property: "feeVehicleCleaning",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Energiepauschale",
                  property: "feeEnergy",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz Karo",
                  property: "feeVehicleBody",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz Lack",
                  property: "feeVehicleLacquer",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz Elektro Karo",
                  property: "feeVehicleBodyElectric",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz Elektro Lack",
                  property: "feeVehicleLacquerElectric",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz NFZ Karo",
                  property: "feeVehicleBodyCommercial",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Stundenverrechnungssatz NFZ Lack",
                  property: "feeVehicleLacquerCommercial",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Standkosten pro Tag",
                  property: "feeVehicleParkingPerDay",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Entsorgungskosten / Lagerung",
                  property: "feeDisposal",
                  type: "currency",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-arrows": true,
                  label: "Entsorgungskosten Lackmaterial in %",
                  property: "feeDisposalVarnish",
                  step: "0.01",
                  type: "number",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-arrows": true,
                  label: "Lackmaterial in %",
                  property: "lacquerMaterial",
                  step: "0.01",
                  type: "number",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-arrows": true,
                  label: "UPE Aufschlag in %",
                  property: "surchargeListPrice",
                  step: "0.01",
                  type: "number",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  "hide-arrows": true,
                  label: "Klein-/Verbrauchsmat. Aufschlag in %",
                  property: "feeConsumables",
                  step: "0.01",
                  type: "number",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Signatur Freitext",
                  property: "signatureText",
                  type: "autogrowtextarea",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }